import React from 'react';
import { SHAPE_CHOICES, classifySeriesShape } from '../../utils/seriesGetIdeas';
import './SeriesShapeChooser.css';

/**
 * The three series-shape cards (#789 / #792).
 * Get Book Ideas shows them when the shape is unknown.
 * Series Discovery shows the same three even when a shape
 * is already remembered. Choosing writes ends_or_continues.
 * It does not start a book or rewrite Timeline pins.
 */
export default function SeriesShapeChooser({
  remembered,
  onChoose,
  saving = false,
  lede,
  flush = false,
}) {
  const current = classifySeriesShape(remembered);
  const className = flush
    ? 'series-shape-chooser series-shape-chooser--flush'
    : 'series-shape-chooser';

  return (
    <section className={className} data-testid="series-shape-choices">
      {lede ? <p className="series-shape-chooser__lede">{lede}</p> : null}
      <ul className="series-shape-chooser__cards">
        {SHAPE_CHOICES.map((choice) => {
          const selected = current === choice.id;
          return (
            <li
              key={choice.id}
              className={
                selected
                  ? 'series-shape-chooser__card is-remembered'
                  : 'series-shape-chooser__card'
              }
            >
              <p className="series-shape-chooser__title">{choice.label}</p>
              <p className="series-shape-chooser__line">{choice.detail}</p>
              <button
                type="button"
                aria-pressed={selected}
                disabled={saving || selected}
                onClick={() => onChoose(choice.persist)}
              >
                {choice.label}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
